import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

export default function ContactoPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />

      {/* Hero Section */}
      <section className="relative py-16 md:py-24 bg-card">
        <div className="container mx-auto px-4 md:px-6 max-w-7xl">
          <div className="text-center max-w-3xl mx-auto">
            <p className="text-primary text-sm font-bold uppercase tracking-widest mb-4">
              Estamos para servirte
            </p>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight uppercase text-foreground mb-6">
              Contacto
            </h1>
          </div>
        </div>
      </section>

      {/* About Us Section */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-4 md:px-6 max-w-7xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
            {/* Quiénes somos */}
            <div className="space-y-6">
              <div>
                <p className="text-primary text-sm font-bold uppercase tracking-widest mb-2">
                  Sobre Nosotros
                </p>
                <h2 className="text-3xl md:text-4xl font-bold uppercase tracking-tight text-foreground mb-6">
                  ¿Quiénes somos?
                </h2>
                <p className="text-muted-foreground leading-relaxed text-lg">
                  Somos una empresa mexicana con actividad en el ramo automotriz, especializados en la venta y/o compra de salvamentos, con presencia desde 2000. Donde encontrarás todo tipo de vehículos para reparar o desarmar a un bajo costo.
                </p>
              </div>
              
              <div className="pt-6">
                <h3 className="text-2xl font-bold uppercase tracking-tight text-foreground mb-4">
                  ¿Qué hacemos?
                </h3>
                <p className="text-muted-foreground leading-relaxed text-lg">
                  Ofrecemos una amplia gama de vehículos seminuevos y equipo pesado a un bajo costo para su reparación y comercialización contando que son autos con fácil reparación.
                </p>
              </div>
            </div>

            {/* Contact Info */}
            <div className="bg-card border border-border rounded-sm p-6 md:p-8 space-y-6">
              <h3 className="text-2xl font-bold uppercase tracking-tight text-foreground mb-6">
                Información de Contacto
              </h3>
              
              {/* Phones */}
              <div className="space-y-3">
                <p className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">
                  Teléfonos
                </p>
                <div className="space-y-2">
                  <a 
                    href="tel:+523314566426" 
                    className="flex items-center gap-3 text-foreground hover:text-primary transition-colors"
                  >
                    <Phone className="w-5 h-5 text-primary flex-shrink-0" />
                    <span className="text-lg">33 1456 6426</span>
                  </a>
                  <a 
                    href="tel:+523319560912" 
                    className="flex items-center gap-3 text-foreground hover:text-primary transition-colors"
                  >
                    <Phone className="w-5 h-5 text-primary flex-shrink-0" />
                    <span className="text-lg">33 1956 0912</span>
                  </a>
                  <a 
                    href="tel:+523325483444" 
                    className="flex items-center gap-3 text-foreground hover:text-primary transition-colors"
                  >
                    <Phone className="w-5 h-5 text-primary flex-shrink-0" />
                    <span className="text-lg">33 2548 3444</span>
                  </a>
                </div>
              </div>

              {/* Email */}
              <div className="space-y-3 pt-4 border-t border-border">
                <p className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">
                  Correo Electrónico
                </p>
                <a 
                  href="mailto:mondo_samuel@yahoo.com.mx" 
                  className="flex items-center gap-3 text-foreground hover:text-primary transition-colors"
                >
                  <Mail className="w-5 h-5 text-primary flex-shrink-0" />
                  <span>mondo_samuel@yahoo.com.mx</span>
                </a>
              </div>

              {/* Address */}
              <div className="space-y-3 pt-4 border-t border-border">
                <p className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">
                  Dirección
                </p>
                <div className="flex items-start gap-3 text-foreground">
                  <MapPin className="w-5 h-5 text-primary flex-shrink-0 mt-1" />
                  <span>Periferico Poniente 5380-A, El Colli 45070, Zapopan, Jal.</span>
                </div>
              </div>

              {/* Hours */}
              <div className="space-y-3 pt-4 border-t border-border">
                <p className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">
                  Horarios de Atención
                </p>
                <div className="space-y-2">
                  <div className="flex items-center gap-3 text-foreground">
                    <Clock className="w-5 h-5 text-primary flex-shrink-0" />
                    <div>
                      <span className="font-medium">Lunes - Viernes:</span> 09:00 AM - 06:00 PM
                    </div>
                  </div>
                  <div className="flex items-center gap-3 text-foreground">
                    <Clock className="w-5 h-5 text-primary flex-shrink-0" />
                    <div>
                      <span className="font-medium">Sábado:</span> 09:00 AM - 02:00 PM
                    </div>
                  </div>
                </div>
              </div>

              {/* WhatsApp Button */}
              <div className="pt-4">
                <a 
                  href="https://api.whatsapp.com/send?phone=523325483444&text=Hola,%20me%20interesa%20información"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whatsapp-btn w-full justify-center"
                >
                  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                  Contactar por WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Google Maps Section */}
      <section className="py-8 md:py-12">
        <div className="container mx-auto px-4 md:px-6 max-w-7xl">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold uppercase tracking-tight text-foreground">
              Encuéntranos
            </h2>
          </div>
          <div className="rounded-sm overflow-hidden border border-border">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14933.677989532547!2d-103.4446518!3d20.6525055!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xc412fa1f4b42f2ce!2sChocados%20GDL!5e0!3m2!1sen!2smx!4v1630888114400!5m2!1sen!2smx"
              width="100%" 
              height="450" 
              style={{ border: 0 }}
              allowFullScreen="" 
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ubicación de Chocados GDL"
              data-testid="google-map"
            />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
